/* =============================================================
   AADHAV – PROFIT & LOSS SELECTORS
============================================================= */

/* BASE */
export const selectProfitLossState = (state) =>
  state?.admin?.profitLoss ?? {};

/* DATA */
export const selectProfitLossData = (state) => {
  const data = selectProfitLossState(state).data;

  if (!Array.isArray(data)) {
    console.warn("⚠️ ProfitLoss data not array:", data);
    return [];
  }

  return data;
};

/* SUMMARY */
export const selectProfitLossSummary = (state) =>
  selectProfitLossState(state).summary ?? {
    income: 0,
    expense: 0,
    profit: 0,
  };

/* LOADING */
export const selectProfitLossLoading = (state) =>
  Boolean(selectProfitLossState(state).loading);

/* ERROR */
export const selectProfitLossError = (state) =>
  selectProfitLossState(state).error ?? null;